/**
 * Perform a rudimentary check if the given string is an html string.
 */
export function isHtmlString(value: string): boolean {
  const container = document.createElement('div');

  container.innerHTML = value;

  return container.innerText !== value;
}
